module.exports = __webpack_public_path__ + "static/media/daedalus.4ac63272.jpg";